var parent = require('../../es/symbol');

require('../../modules/esnext.symbol.async-dispose');

require('../../modules/esnext.symbol.dispose');

require('../../modules/esnext.symbol.observable');

require('../../modules/esnext.symbol.pattern-match'); // TODO: Remove from `core-js@4`


require('../../modules/esnext.symbol.replace-all');

module.exports = parent;